import { formatGreeceDateTime } from './timezone';

/**
 * Format a number as currency (EUR)
 * @param {number} amount - The amount to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '€0.00';
  
  try {
    return `€${parseFloat(amount).toFixed(2)}`;
  } catch (error) {
    console.error("Error formatting currency:", error);
    return `€${amount}`;
  }
};

/**
 * Format a date for display in Greece timezone
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  if (!date) return '';
  
  try {
    console.log("Formatting date:", date);
    
    // Use the Greece timezone utility for consistent formatting
    return formatGreeceDateTime(date, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return String(date);
  }
};

/**
 * Format a date for table displays (shorter format) in Greece timezone
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string (short format)
 */
export const formatDateShort = (date) => {
  if (!date) return '';
  
  try {
    console.log("Formatting date short:", date);
    
    // Use the Greece timezone utility for consistent formatting
    return formatGreeceDateTime(date, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    console.error("Error formatting date short:", error);
    return String(date);
  }
}; 